module.exports = __webpack_public_path__ + "img/nakahara-makiko.60cfb34c.jpg";